// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__uH3iq","actions":"GroupTable_actions__1UjFV","deleteModalFooter":"GroupTable_deleteModalFooter__GHqiy"};